var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5C9.82843 4.5 10.5 3.82843 10.5 3C10.5 2.17157 9.82843 1.5 9 1.5C8.17157 1.5 7.5 2.17157 7.5 3C7.5 3.82843 8.17157 4.5 9 4.5Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2111 5.763C11.1616 5.61353 11.0663 5.48348 10.9386 5.39136C10.811 5.29925 10.6575 5.24978 10.5001 5.25H7.50006C7.34266 5.24989 7.18923 5.29941 7.06159 5.3915C6.93395 5.4836 6.83859 5.61359 6.78906 5.763L5.28906 10.263L6.62031 10.7078L6.00006 13.5H7.50006V16.5H10.5001V13.5H12.0001L11.3798 10.707L12.7111 10.2623L11.2111 5.763Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleBlack);
export default __webpack_public_path__ + "static/media/female_black.f2b5c63961f99a8056de2e4115186a63.svg";
export { ForwardRef as ReactComponent };